<template>
  <!--
  This is meant to be a simple preview of a meeting
  A visual confirmation that you have selected the correct meeting
  For example, when editing or deleting a meeting.
  -->
  <div class="tw-flex tw-flex-col tw-bg-gray-100 tw-p-2 tw-rounded">
    <span class="tw-font-bold tw-text-gray-500">
      {{ meeting.meeting_date }}
    </span>
    <span class="tw-text-sm tw-text-gray-500">{{ summaryPreview }}</span>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'MeetingGlance',
  components: {
    // Subcomponents
  },
  props: {
    // Inputs
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Local variables
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    summaryPreview() {
      const maxLength = 50;
      if (this.meeting.summary.length < maxLength) {
        return this.meeting.summary;
      }
      return this.meeting.summary.slice(0, maxLength) + '...';
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
